<template>
    <div class="flex-col page">
        <div class="flex-col group_3">
            <div class="flex-col group_4">
                <div class="flex-col section_1">
                    <!-- <CarCard :carDetails="carDetail"></CarCard> -->
                    <div class="justify-between group_5">
                        <div class="flex-row">
                            <img :src="this.mixin_imgs[this.getOSSImg(carDetail.carImg)]" class="image_4" />
                            <div class="flex-col group_7">
                                <span class="text_3">{{ carDetail.carTypeName }}</span>
                                <div class="flex-row group_8">
                                    <span class="text_4">{{ carDetail.carTypeLevel }}</span>
                                    <div class="section_2" v-if="carDetail.carTypePower"></div>
                                    <span class="text_5">{{ carDetail.carTypePower }}</span>
                                </div>
                                <div class="flex-row group_9">
                                    <span class="text_6">定金</span>
                                    <span class="text_7">¥</span>
                                    <span class="text_8">{{ carDetail.depositPrice }}</span>
                                </div>
                            </div>
                        </div>
                        <span class="text_9">{{ carDetail.orderStateDesc }}</span>
                    </div>
                    <div class="justify-between group_10">
                        <span class="text_10">姓名</span>
                        <span class="text_11">{{ carDetail.userName }}</span>
                    </div>
                    <div class="justify-between group_11">
                        <span class="text_12">手机号</span>
                        <span class="text_13">{{ carDetail.phone }}</span>
                    </div>
                </div>
                <div class="flex-col section_3">
                    <div class="justify-between">
                        <span class="text_14">订单编号</span>
                        <div class="flex-row">
                            <span class="text_15">{{ carDetail.orderId }}</span>
                            <div class="section_4">
                                <!--*-->
                            </div>
                            <span class="text_16" @click="copy(carDetail.orderId)">复制</span>
                        </div>
                    </div>
                    <div class="justify-between group_14">
                        <span class="text_17">付款时间</span>
                        <span class="text_18">{{ carDetail.lastPayTime }}</span>
                    </div>
                    <div class="justify-between group_15">
                        <span class="text_19">付款方式</span>
                        <!-- 只支持支付宝微信 -->
                        <span class="text_20">{{ carDetail.payType == 2 ? "支付宝" : "微信" }}</span>
                    </div>
                </div>
            </div>
            <div class="flex-row section_5">
                <a :href="`tel:${carDetail.commissionerPhone}`"
                    class="flex-col items-center text-wrapper_1 btn">联系专员</a>
                <div v-if="carDetail.orderState == 3" class="flex-col items-center text-wrapper_2 btn"
                    @click="goGetCoupon">我的权益</div>

                <div v-if="carDetail.orderState == 2" @click="goPay"
                    class="flex-col items-center text-wrapper_2 btn payBtn">
                    立即支付
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getOrderDetail } from '../api'
import { getImgMixin } from '../getImg_mixin'
import CarCard from '../_components/CarCard.vue'
export default {
    components: { CarCard },
    data() {
        return {
            carDetail: {}
        };
    },
    mixins: [getImgMixin],
    methods: {

        goPay() {
            this.$router.push({
                path: "/salePassat/pay",
                query: {
                    orderId: this.carDetail.orderId,
                    from: "orderlist",
                    apiPath: "",// todo
                    returnRouter: "/salePassat/orderlist",
                    payAmount: "0.01" || this.carDetail.depositPrice, // todo
                },
            }); //传orderId
        },
        copy(item) {
            let copyInput = document.createElement('input');//创建input元素
            document.body.appendChild(copyInput);//向页面底部追加输入框
            copyInput.setAttribute('value', item);//添加属性，将url赋值给input元素的value属性
            copyInput.select();//选择input元素
            document.execCommand("Copy");//执行复制命令
            this.$toast("已复制！");
            copyInput.remove();//删除动态创建的节点
        },
        goGetCoupon() {
            console.log(this.carDetail.orderId)
            this.$router.push({ path: `/salePassat/getCoupon/${this.carDetail.orderId}` })
        }
    },
    created() {
        getOrderDetail({ orderId: this.$route.params.orderId }).then(res => {
            this.carDetail = {
                ...res.result,
                lastPayTime: new Date(res.result.lastPayTime).toLocaleString(),
                name: res.result.carTypeName
            }
        })
    }
};
</script>

<style scoped lang="scss">
@import '../common.css';
.page {
    padding-top: 16px;
    padding-bottom: 150px;
    background-color: #f5f5f5;
    width: 100%;
    overflow-x: hidden;
    height: calc(100% - 144px);

    .group_3 {
        .group_4 {
            padding: 0 0.21rem;

            .section_1 {
                padding: 0 0.32rem 24px;
                background-color: #ffffff;
                border-radius: 0.21rem;

                .group_5 {
                    padding: 0.32rem 0 0.41rem;
                    border-bottom: solid 0.027rem #e0e0e0;

                    .text_9 {
                        color: #999999;
                        font-size: 0.37rem;
                        font-family: 'PingFang SC';
                        font-weight: 500;
                        line-height: 0.53rem;
                        min-width: 90px;
                        text-align: right;
                    }

                    .image_4 {
                        width: 2.83rem;
                        height: 1.41rem;
                    }

                    .group_7 {
                        margin-left: 0.32rem;
                        width: 326px;

                        .text_3 {
                            color: #141e25;
                            font-size: 0.43rem;
                            font-family: 'PingFang SC';
                            font-weight: 500;
                            line-height: 0.59rem;
                        }

                        .group_8 {
                            margin-top: 0.11rem;

                            .text_4 {
                                color: #666666;
                                font-size: 0.27rem;
                                font-family: 'PingFang SC';
                                line-height: 0.37rem;
                                text-transform: lowercase;
                            }

                            .section_2 {
                                margin: 0.11rem 0 0.053rem 0.11rem;
                                background-color: #e0e0e0;
                                width: 0.013rem;
                                height: 0.21rem;
                            }

                            .text_5 {
                                margin-left: 0.12rem;
                                margin-right: 1.01rem;
                                color: #666666;
                                font-size: 0.27rem;
                                font-family: 'PingFang SC';
                                line-height: 0.37rem;
                            }
                        }

                        .group_9 {
                            margin-top: 0.21rem;

                            .text_6 {
                                margin-top: 0.11rem;
                                color: #333333;
                                font-size: 0.32rem;
                                font-family: 'PingFang SC';
                                line-height: 0.45rem;
                            }

                            .text_7 {
                                margin-left: 0.13rem;
                                margin-top: 0.11rem;
                                color: #333333;
                                font-size: 0.32rem;
                                font-family: 'PingFang SC';
                                line-height: 0.45rem;
                            }

                            .text_8 {
                                margin-right: 0.51rem;
                                color: #333333;
                                font-size: 0.43rem;
                                font-family: 'PingFang SC';
                                font-weight: 500;
                                line-height: 0.59rem;
                            }
                        }
                    }
                }

                .group_10 {
                    margin-top: 0.32rem;

                    .text_10 {
                        color: #666666;
                        font-size: 0.37rem;
                        font-family: 'PingFang SC';
                        line-height: 0.53rem;
                    }

                    .text_11 {
                        color: #333333;
                        font-size: 0.37rem;
                        font-family: 'PingFang SC';
                        font-weight: 500;
                        line-height: 0.53rem;
                    }
                }

                .group_11 {
                    margin-top: 0.32rem;

                    .text_12 {
                        color: #666666;
                        font-size: 0.37rem;
                        font-family: 'PingFang SC';
                        line-height: 0.53rem;
                    }

                    .text_13 {
                        color: #333333;
                        font-size: 0.37rem;
                        font-family: 'PingFang SC';
                        font-weight: 500;
                        line-height: 0.53rem;
                    }
                }
            }

            .section_3 {
                margin-top: 0.21rem;
                padding: 0.32rem 0.32rem 24px;
                background-color: #ffffff;
                border-radius: 0.21rem;

                .group_14 {
                    margin-top: 0.32rem;

                    .text_17 {
                        color: #999999;
                        font-size: 0.37rem;
                        font-family: 'PingFang SC';
                        line-height: 0.53rem;
                    }

                    .text_18 {
                        color: #666666;
                        font-size: 0.37rem;
                        font-family: 'PingFang SC';
                        line-height: 0.53rem;
                    }
                }

                .group_15 {
                    margin-top: 0.32rem;

                    .text_19 {
                        color: #999999;
                        font-size: 0.37rem;
                        font-family: 'PingFang SC';
                        line-height: 0.53rem;
                    }

                    .text_20 {
                        color: #666666;
                        font-size: 0.37rem;
                        font-family: 'PingFang SC';
                        line-height: 0.53rem;
                    }
                }

                .text_14 {
                    color: #999999;
                    font-size: 0.37rem;
                    font-family: 'PingFang SC';
                    line-height: 0.53rem;
                }

                .text_15 {
                    color: #666666;
                    font-size: 0.37rem;
                    font-family: 'PingFang SC';
                    line-height: 0.53rem;
                }

                .section_4 {
                    margin: 0.11rem 0 0.11rem 0.17rem;
                    flex-shrink: 0;
                    background-color: #e0e0e0;
                    width: 0.027rem;
                    height: 0.32rem;
                }

                .text_16 {
                    margin-left: 0.21rem;
                    color: #333333;
                    font-size: 0.37rem;
                    font-family: 'PingFang SC';
                    line-height: 0.53rem;
                }
            }
        }

        .section_5 {
            justify-content: flex-end;
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            height: 144px;
            background-color: #ffffff;
            border-top: solid 0.013rem #e0e0e0;
            padding-right: 40px;

            .btn {
                margin-top: 24px;
                height: 88px;
                line-height: 88px;
                font-size: 32px;
            }

            .text-wrapper_1 {
                border-radius: 0.59rem;
                width: 212px;
                border: solid 0.013rem #cccccc;
                margin: 24px 16px 0 40px;

            }

            .text-wrapper_2 {
                background-color: #02d644;
                border-radius: 0.59rem;
                width: 442px;
                color: white;

                &.payBtn {
                    background-image: linear-gradient(109.7deg,
                            #ff5933 0%,
                            #ff5933 -20.71%,
                            #ff3000 120.71%,
                            #ff3000 100%);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// orderDetail.vue?0d40cc7a